import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderDateFieldFormFieldTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-date-field.js'
import { renderDefaultValueChangeHandler } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-default-value-change-handler.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'

export function renderDateField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  context: FieldRenderContext
): string {
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  const onChange = defaultValueFromHandler
    ? renderDefaultValueChangeHandler({
        indent: indent,
        defaultValueFromHandler: defaultValueFromHandler
      })
    : 'formField.onChange'
  return renderDateFieldFormFieldTemplate({
    indent: indent,
    fieldName: field.name,
    formItemProps: formItemProps(field),
    labelWithDescription: labelWithDescription(formLabel(field, label), hintJSX, `${indent}      `),
    onChange: onChange,
    toLowerCase: label.toLowerCase()
  })
}
